import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { MdLogout, MdSettings, MdMenu, MdDarkMode, MdLightMode } from "react-icons/md";
import { useAuth } from "../../context/AuthContext";
import NotificationBell from "./NotificationBell";
import toast from "react-hot-toast";
import "./Navbar.css";

const pageTitles = {
  "/dashboard": "Dashboard",
  "/tasks": "My Tasks",
  "/enrollments": "Enrollments",
  "/admin/enrollments": "All Enrollments",
  "/profile": "Profile",
  "/admin/staff": "Staff Management",
  "/admin/tasks": "Task Management",
  "/admin/organizations": "Organizations",
};

const Navbar = ({ onMenuClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    if (saved === "dark" || saved === "light") return saved;
    const prefersDark =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);
  const title =
    pageTitles[location.pathname] ||
    (location.pathname.startsWith("/tasks/") && location.pathname !== "/tasks"
      ? "Task Details"
      : "TaskFlow");

  const handleLogout = async () => {
    await logout();
    toast.success("Logged out");
    navigate("/login");
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          type="button"
          className="topbar-menu-btn"
          onClick={onMenuClick}
          aria-label="Open menu"
          title="Menu"
        >
          <MdMenu size={24} />
        </button>
        <h1 className="topbar-title">{title}</h1>
      </div>
      <div className="topbar-right">
        <NotificationBell />
        <button
          type="button"
          className="topbar-icon-btn"
          onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
          title={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <MdLightMode /> : <MdDarkMode />}
        </button>
        <Link
          to="/profile"
          className="topbar-icon-btn"
          title="Settings"
          aria-label="Settings"
        >
          <MdSettings />
        </Link>
        <button
          type="button"
          className="topbar-icon-btn topbar-icon-btn-logout"
          onClick={handleLogout}
          title="Logout"
          aria-label="Logout"
        >
          <MdLogout />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
